import { Injectable, Signal } from '@angular/core';
import { IContactData, IContactModel, IModelState } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { ContactActions, ContactSelectors, IContactState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class ContactStore extends StateAccessService<IContactState> {
  readonly state$: Observable<IContactState>;

  readonly data$$: Signal<IContactData>;
  readonly model$$: Signal<IContactModel>;

  readonly clubMembershipState$$: Signal<IModelState>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(ContactSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(ContactSelectors.data);
    this.clubMembershipState$$ = this.stateFacade.selectSignal$(ContactSelectors.clubMembership);
  }

  dispatchContactReset() {
    this.stateFacade.dispatch(ContactActions.reset());
  }
  dispatchUpdateModel({ model }: { model: IContactModel }) {
    this.stateFacade.dispatch(ContactActions.updateModel({ model }));
  }
  dispatchUpdateClubMembershipState(clubMembershipState: IModelState) {
    this.stateFacade.dispatch(ContactActions.updateClubMembership({ modelState: clubMembershipState }));
  }

  dispatchContactLoad() {
    this.stateFacade.dispatch(ContactActions.load());
  }
  dispatchContactLoadSuccess({ data }: { data: IContactData }) {
    this.stateFacade.dispatch(ContactActions.loadSuccess({ data }));
  }

  dispatchContactSubmit() {
    this.stateFacade.dispatch(ContactActions.submit());
  }

  dispatchContactSubmitSuccess({ model }: { model: IContactModel }) {
    this.stateFacade.dispatch(ContactActions.submitSuccess({ model }));
  }
}
